import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiTooltip: {
            defaultProps: {
                arrow: true,
                enterTouchDelay: 0,
                placement: 'bottom',
            },
            styleOverrides: {
                arrow: {
                    color: designTokens.color.gray.slateDark.value,
                },
                tooltip: {
                    backgroundColor: designTokens.color.gray.slateDark.value,
                    fontSize: designTokens.typography.body.short1.size.value,
                    lineHeight: designTokens.typography.body.short1.lineHeight.value,
                    padding: theme.spacing(1, 2, 1.25, 2),
                    borderRadius: theme.spacing(0.25),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=tooltipTheme.js.map